import { Box, Button, FormHelperText, Grid, Typography } from "@mui/material";
import { Field, FieldArray, useField } from "formik";
import DateInput from "../../../components/DateInput";
import { MinusButton, PlusButton } from "../../../components/Buttons";
import { getDateAfter, getHyphenedDate } from "../../../utils/utils";

/** 課税期間履歴フォーム */
export default function InvoiceRegistrationHistoryForm ({errors, ...helpers }) {

  const historyList
    = helpers.values.invoiceRegistrationHistoryList
      .map((h, idx) => ({...h, listIndex: idx}))
      .filter((h) => !h.isDeleted);
  
  return (  
    <FieldArray
      name="invoiceRegistrationHistoryList"
    >
      {
        (arrayHelper) => (
          historyList.length > 0
          ? (
            <InvoiceRegistrationHistoryTable
              historyList = {historyList}
              errors = {errors}
              arrayHelper = {arrayHelper}
              {...helpers}
            />
          )
          : (
            <CreateRegistrationHistoryButton arrayHelper={arrayHelper} />
          )
        )
      }
    </FieldArray>
  )
};

/** 課税期間履歴テーブル */
const InvoiceRegistrationHistoryTable = ({historyList, errors, ...helpers}) => {
 
  const getErrorMessage = (listIndex) => {
    if (!errors || !errors[listIndex]) {
      return "";
    }

    return errors[listIndex]
  }

  return (
    <Box>
      {
        historyList.map((h, index) => (
          <InvoiceRegistrationHistoryRow
            key={`invoiceRegistrationHistoryList-${h.listIndex}`}
            index={index}
            listIndex={h.listIndex}
            {...helpers}
            errorMessage={getErrorMessage(h.listIndex)}
          />
        ))
      }
    </Box>
  );
}

/** 課税期間履歴の行 */
const InvoiceRegistrationHistoryRow = ({index, listIndex, errorMessage, ...helpers}) => {

  const {handleChange, setFieldValue, refs, arrayHelper} = helpers;

  const onClickClearRegistrationDate = (event) => {
    setFieldValue(`invoiceRegistrationHistoryList.${listIndex}.registrationDate`, null);
  }

  const onClickClearCancellationDate = (event) => {
    setFieldValue(`invoiceRegistrationHistoryList.${listIndex}.cancellationDate`, null);
  }

  const onClickAddHistoryInfo = (event) => {
    if (arrayHelper) {
      arrayHelper.insert(listIndex + 1, {
        registrationHistoryId: null,
        registrationDate: getHyphenedDate(new Date()),
        cancellationDate: null,
        isDeleted: false,
      })
    }
  }

  const onClickDeleteHistoryInfo = (event) => {
    setFieldValue(`invoiceRegistrationHistoryList.${listIndex}.isDeleted`, true);
  }

  return (
      <Box marginBottom={1}>
        <Grid container alignItems="center" spacing={1} >
          <Grid item width={20}>
            <Typography color={errorMessage.length > 0 ? "error" : "black"}>{index + 1}</Typography>
          </Grid>
          <Grid item width={320}>
            登録日
            <Field 
              name={`invoiceRegistrationHistoryList.${listIndex}.registrationDate`}
              as={DateInputField}
              onChange={handleChange}
              id={`invoiceRegistrationHistoryList-${listIndex}-registrationDate`}
              inputRef={refs.current[`invoiceRegistrationHistoryList.${listIndex}.registrationDate`]}
              sx={{marginX: 1}}                   
            />
            <Button variant="outlined" onClick={onClickClearRegistrationDate}>
              クリア
            </Button>
          </Grid>
          <Grid item width={320}>
            解除日
            <Field 
              name={`invoiceRegistrationHistoryList.${listIndex}.cancellationDate`}
              as={DateInputField}
              onChange={handleChange}
              id={`invoiceRegistrationHistoryList-${listIndex}-cancellationDate`}
              inputRef={refs.current[`invoiceRegistrationHistoryList.${listIndex}.cancellationDate`]}
            />
            <Button variant="outlined" onClick={onClickClearCancellationDate}>
              クリア
            </Button>
          </Grid>
          <Grid item xs>
            <PlusButton onClick={onClickAddHistoryInfo} />
          </Grid>
          <Grid item xs>
            <MinusButton onClick={onClickDeleteHistoryInfo} />
          </Grid>
        </Grid>
        <FormHelperText error={errorMessage.length > 0}>{errorMessage}</FormHelperText>
      </Box>
  );
}

/** 日付input用Field */
const DateInputField = (props) => {

  const [field, meta, helper] = useField(props);

  return (
    <DateInput
      {...field}
      setValue={helper.setValue}
      sx={{marginX: 1}}
    />
  );
}

/** 課税履歴追加ボタン */
const CreateRegistrationHistoryButton = ({arrayHelper}) => {

  const onClickCreateRegistrationHistoryButton = (event) => {
    if (arrayHelper) {
      arrayHelper.push({
        registrationHistoryId: null,
        registrationDate: getHyphenedDate(new Date()),
        cancellationDate: null,
        isDeleted: false,
      })
    }
  }

  return (
    <Button variant="outlined" onClick = {onClickCreateRegistrationHistoryButton}>
      課税履歴追加
    </Button>
  )
}
